import { useContext } from "react";
import { PageContext, PageType } from "../../App";

type InfoBoxPropsType = {
    description : string;
    button : {
        text : string;
        path : PageType;
        title? : string;
    }
}

const InfoBox = ({ description, button } : InfoBoxPropsType ) => {
    const { handleChangePage } = useContext(PageContext);

  return (
    <div className="grid-section-info-box">
        <p className="description">{description}</p>
        <button
            // to={homePageData.gridSection.boxOne.button.path}
            className="button"
            onClick={() => handleChangePage(button.path)}
            title={button.title}
            aria-label={button.title}
        >{button.text}</button>
    </div>
  )
}

export default InfoBox